import { ImportFixDTO } from './../../../../base/models/models.swagger.generated';
import { Component, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ImportConfigurationProtocolEditFormService } from './import-configuration-protocol-edit-form.service';
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-angular-popups';
import { ImportProtocolDTO } from 'src/app/base/models/models.swagger.generated';
import { ImportConfigurationProtocolEditFormFileHandlingComponent } from './import-configuration-protocol-edit-form-file-handling/import-configuration-protocol-edit-form-file-handling.component';
import { ImportConfigurationProtocolEditFormHeaderComponent } from './import-configuration-protocol-edit-form-header/import-configuration-protocol-edit-form-header.component';
import { ImportConfigurationProtocolEditFormLogListComponent } from './import-configuration-protocol-edit-form-log-list/import-configuration-protocol-edit-form-log-list.component';

@Component({
    selector: 'app-import-configuration-protocol-edit-form',
    templateUrl: './import-configuration-protocol-edit-form.component.html',
    styleUrls: ['./import-configuration-protocol-edit-form.component.scss'],
    imports: [ImportConfigurationProtocolEditFormHeaderComponent, ImportConfigurationProtocolEditFormFileHandlingComponent, ImportConfigurationProtocolEditFormLogListComponent]
})
export class ImportConfigurationProtocolEditFormComponent implements AfterViewInit {

  @Input()
  public set protocol(value: ImportProtocolDTO) {
    if (this._protocol === value) {
      return;
    }
    this._protocol = value;
    if (this._protocol && !this._protocol.logEntries) {
      this.protocolEditFormService.loadFullProtocol(this._protocol.id, null).subscribe((protocol: ImportProtocolDTO) => {
        this._protocol = protocol;
        this.cdr.detectChanges();
      });
    }
  }

  public get protocol(): ImportProtocolDTO {
    return this._protocol;
  }

  private _protocol: ImportProtocolDTO;

  constructor(private protocolEditFormService: ImportConfigurationProtocolEditFormService,
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit() {
    createSpinner({
      // Specify the target for the spinner to show
      target: document.getElementById('file-handling')
    });
  }

  public import(data: ImportFixDTO) {
    showSpinner(document.getElementById('file-handling'));
    this.protocolEditFormService.import(data).subscribe({next: (protocol: ImportProtocolDTO) => {
      if (protocol) {
        this._protocol = protocol;
      }
      hideSpinner(document.getElementById('file-handling'));
    }, error: () => {
      hideSpinner(document.getElementById('file-handling'));
    }});
  }

  public onIterationChanged(iteration:number){
    showSpinner(document.getElementById('file-handling'));
    this.protocolEditFormService.loadFullProtocol(this._protocol.id, iteration).subscribe((protocol: ImportProtocolDTO) => {
      this._protocol = protocol;
      hideSpinner(document.getElementById('file-handling'));
    });
  }
}
